import { render, staticRenderFns } from "./freeUse.vue?vue&type=template&id=6f0a6c71&scoped=true&"
import script from "./freeUse.vue?vue&type=script&lang=js&"
export * from "./freeUse.vue?vue&type=script&lang=js&"
import style0 from "./freeUse.vue?vue&type=style&index=0&id=6f0a6c71&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f0a6c71",
  null
  
)

export default component.exports